import { useContext } from 'react';
import { getFilteredModels, getTrimFilterValues } from '../../ModelFiltersContext/utils';
import { ModelFiltersContext } from '../../ModelFiltersContext';
import { getAllTrimsFromModelData } from './utils';
import { mapOffersToModelsWithPrice } from '../special_offers_filter/utils';
/**
 * @param {Object} filter - filter object
 * @param {String} category - filter category
 * @param {String} item - filter item
 * @param {Object} modelData - from Sitecore route
 * @returns true if no filtered trims have the specified item
 */
const useIsFilterItemDisabled = (modelData) => {
    const modelFiltersContext = useContext(ModelFiltersContext);
    const { offersResponse } = modelFiltersContext || {};
    const allTrims = getAllTrimsFromModelData(modelData);
    const allTrimsWithOffers = mapOffersToModelsWithPrice(allTrims, offersResponse.data);
    return (filter, category, item) => {
        var _a, _b, _c;
        if (typeof window === 'undefined')
            return false;
        if ((filter === null || filter === void 0 ? void 0 : filter.onlyFutureVehicles) || (filter === null || filter === void 0 ? void 0 : filter.onlyNsx))
            return true;
        const allTrimsWithFilterValues = allTrimsWithOffers === null || allTrimsWithOffers === void 0 ? void 0 : allTrimsWithOffers.map(trim => ({
            ...trim,
            filterValues: getTrimFilterValues(trim),
        }));
        const filteredTrims = getFilteredModels(allTrimsWithFilterValues, filter === null || filter === void 0 ? void 0 : filter.values);
        const trimCountForFilterItem = (_c = getFilteredModels(filteredTrims, {
            ...filter === null || filter === void 0 ? void 0 : filter.values,
            [category]: (_b = (_a = filter === null || filter === void 0 ? void 0 : filter.values) === null || _a === void 0 ? void 0 : _a[category]) === null || _b === void 0 ? void 0 : _b.concat(item),
        })) === null || _c === void 0 ? void 0 : _c.length;
        return trimCountForFilterItem === 0;
    };
};
export default useIsFilterItemDisabled;
